import { WidgetValuesReadConfiguration, ReadType, AggregationConfiguration, IBindable } from '../../models/';
import { ITableByGroupService, IwidgetIntervalHelperService } from '../../services/index';
import { DataWidgetBase, IdataWidget } from '../index';
import { TableByGroupWidgetConfiguration } from './index';
import { Helper } from '../../common/';
import { TableByGroupDefinition as definition } from './tableByGroup.definition';

export class TableByGroupWidget extends DataWidgetBase implements IdataWidget {
    baseType = definition.baseType;
    col = 0;
    configuration: TableByGroupWidgetConfiguration;
    exportFormats = ['csv'];
    exportToCsv: () => void;
    group = definition.group;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    selectedGroup: string;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(private _tableByGroupService: ITableByGroupService, intervalHelper: IwidgetIntervalHelperService) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new TableByGroupWidgetConfiguration();
    }

    getReadConfiguration(beginDate, endDate): WidgetValuesReadConfiguration {
        const aggregation: AggregationConfiguration = {
            period: null,
            mode: this.configuration.aggregationMode
        };
        return this.getReadConfigurationBase(
            beginDate,
            endDate,
            this.configuration.series,
            this.configuration,
            aggregation,
            this.configuration.hasQuality,
            false, false, false, false,
            ReadType.AggregatedValue,
            this.configuration.hasAlarm,
            this.configuration.options?.variableTypeGuid,
            this.configuration.options?.unitGuid
        );
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        const aggregation: AggregationConfiguration = {
            period: null,
            mode: this.configuration.aggregationMode
        };

        return this._tableByGroupService
            .getSeriesList(this.configuration, this.selectedGroup)
            .then((data: IBindable[]) => this.createConfiguration(
                data,
                aggregation,
                true, false, false, false, false,
                ReadType.AggregatedValue,
                this.configuration.options?.variableTypeGuid,
                this.configuration.options?.unitGuid
            ))
            .catch(() => {
                return this.createConfiguration(
                    [],
                    aggregation,
                    true, false, false, false, false,
                    ReadType.AggregatedValue,
                    this.configuration.options?.variableTypeGuid,
                    this.configuration.options?.unitGuid
                );
            });
    }
}